export const customShadows = [
  'none',
  '0px 2px 1px rgba(3, 109, 235, 0.03), 0px 1px 1px rgba(3, 109, 235, 0.02), 0px 1px 3px rgba(3, 109, 235, 0.12)',
  'none',
  'none',
  '0px 2px 4px rgba(3, 109, 235, 0.03), 0px 4px 5px rgba(3, 109, 235, 0.02), 0px 1px 10px rgba(3, 109, 235, 0.12)',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  '0px 11px 15px rgba(3, 109, 235, 0.03), 0px 24px 38px rgba(3, 109, 235, 0.02), 0px 9px 46px rgba(3, 109, 235, 0.12)'
];
